import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import ArrowDown from "../../../assets/icons/icon-arrow-down.svg";

export const Container = styled.div`
  position: relative;
  width: 100%;
  // 512px fixo no desktop - o mapa do meteoblue logo abaixo (ver MapView em
  // pages/nova-farm/styles.js) teve a altura reduzida nessa mesma medida, pra
  // manter a altura total da coluna. "auto" nos breakpoints menores (ver
  // abaixo), senão sobra espaço em branco reservado abaixo do conteúdo (ex.:
  // estado "Nenhum evento encontrado") numa tela estreita.
  height: 512px;
  max-width: 20.625rem;
  min-width: 330px;
  padding: 1rem 1rem 5rem;

  display: flex;
  flex-direction: column;

  border-radius: 0.75rem;
  background-color: #f8f8f9;
  border: 0.3rem solid #f8f8f9;

  @media (max-width: 1310px) {
    height: auto;
    max-width: 100%;
    min-width: 0;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    overflow: visible;
    padding-bottom: 5rem;
  }
`;

export const Header = styled.div`
    display: flex;
    
    align-items: center;
    margin-bottom: 0.5rem;
    justify-content: space-between;
`;

export const CultureSelector = styled.select`
  all: unset;
  padding: 0.5rem 2rem 0.5rem 1rem;

  height: 1rem;
  cursor: pointer;
  max-width: 70px;

  display: block;
  border-radius: 2.5rem;
  text-transform: uppercase;
  border: 0.0625rem solid black;
  appearance: none;
  background-image: url(${ArrowDown});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;

  font-family: 'Lato', sans-serif;
  font-size: 10px;
  font-weight: 800;
  line-height: 150%;
  letter-spacing: 0.1em;
  color: ${theme.colors.gray.Cinza_2};
  text-align: left;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


export const CreateEventButton = styled.button`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;

  border: none;
  border-radius: 0.5rem;
  background-color: #e9f1ff;

  cursor: pointer;

  > p {
    cursor: pointer;
  }

  &:hover {
    background-color: #d8e9ff;
  }
`;

export const PlusIcon = styled.img`
    width: 1.4rem;
    
    margin-right: 0.5rem;
`;

export const EventCard = styled.div`
    width: 100%;
    height: auto;
    padding: 0.5rem;

    gap: 0.5rem;
    display: flex;
    flex-direction: column;

    border-radius: 0.5rem;
    margin-bottom: 0.75rem;
    background-color: white;

    @media (max-width: 768px) {
        width: 85%;
        min-width: 85%;
        max-width: 85%;
        flex-shrink: 0;
        margin-bottom: 0;
    }
`;

export const EventInfo = styled.div`
    gap: 0.3rem;
    display: flex;
    flex-direction: row; 
`;

export const EventCardWrapper = styled.div`
    gap: 0.5rem;
    display: flex;

    @media (max-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 0;
    }
`;

export const CardsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 0.75rem;
    }
`

export const VerticalText = styled.div`
    gap: 0.75rem;
    display: flex;
    text-align: center;
    justify-content: flex-end;
    
    transform: rotate(180deg);
    writing-mode: vertical-rl;
    
    p {
    height: 10.3rem;
    text-align: start;
    border-radius: 0.5rem;
    padding: 0.75rem 0.25rem;
    background-color: #FFFFFF;
  }
`;

export const EventActions = styled.div`
    width: 100%;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const CropBadge = styled.div`
  padding: 0.4rem 0.5rem;
  gap: 4px;
  display: -webkit-box;
  align-items: center;
  margin-right: 0.5rem;

  border-radius: 3rem;
  background-color: #E9ECF0;

  max-width: 140px;
  height: 1.5rem;

  overflow: hidden;
  text-overflow: ellipsis;

  -webkit-box-orient: horizontal;
  -webkit-line-clamp: 1;
  white-space: nowrap; /* necessário para funcionar com clamp */
`;


export const Bullet = styled.div`
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    
    border-radius: 50%;
    background-color: ${theme.colors.gray.Cinza_7};
`;

export const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  // Sem "Nenhum evento encontrado", não tem lista rolável pra proteger do botão
  // flutuante - esse padding só deixava o estado vazio com espaço sobrando
  // embaixo. Com eventos, mantém (última linha da lista não fica atrás do
  // "Criar evento").
  padding-bottom: ${props => props.notFound ? '0' : '4.5rem'};

  display: ${props => props.notFound ? 'flex' : 'block'};
  align-items: ${props => props.notFound ? 'center' : 'initial'};
  justify-content: ${props => props.notFound ? 'center' : 'initial'};

  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1024px) {
    height: auto;
    padding-bottom: ${props => props.notFound ? '0' : '4.5rem'};
  }

  @media (max-width: 768px) {
    overflow-y: hidden;
    overflow-x: scroll;
    padding-bottom: 0.5rem;
  }
`;

export const ButtonSaved = styled.button`
    all: unset;
    width: 100%;
    height: 1.5rem;
    padding: 0.75rem 1rem;

    display: flex;
    margin-top: 1rem;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color: ${(props) => props.disabled ? theme.colors.disabled.Fundo_Desabilitado : theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer;
        text-align: center;
        color: ${(props) => props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.white.Branco};
    }
`;

export const ContainerNewCardRight = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    margin-top: 1.5rem;
    align-items: center;
    justify-content: center;
`;

export const ContainerSavedEvent = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    display: flex;
    margin-top: 2rem;

    border-top: 1px solid ${theme.colors.gray.Cinza_10};
`;

export const TextArea = styled.textarea`
    width: 100%;
    height: 8.25rem;
    padding: 0.875rem 1rem 0.875rem 1rem;

    border-radius: 0.5rem;
    border: 1px solid ${props => props.hasError ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7};

    color: ${theme.colors.gray.Cinza_2};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.bodyP};
    line-height: ${theme.typography.lineHeight.bodyP};
    letter-spacing: 0px;

    ::placeholder{
        color: ${theme.colors.gray.Cinza_7};
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.regular};
        font-size: ${theme.typography.fontSize.bodyP};
        line-height: ${theme.typography.lineHeight.bodyP};
        letter-spacing: 0px;
    }
`;

export const WrapperNewCardRight = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;

  background-color: transparent;
  border-top: 1px solid #FFF;
  border-bottom: 1px solid #FFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const InputAndButton = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 0.5rem;
    display: flex;

    @media (max-width: 479px) {
        align-items: center;
        flex-direction: column;
    }
`;

export const InputButton = styled.button`
    all: unset;

    width: auto;
    height: auto;
    padding: 0.5rem 0.75rem;

    display: flex;
    align-items: center;

    cursor: ${(props => (props.isTotvs || props.disabled) ? 'not-allowed' : 'pointer')};
    
    opacity: ${(props => (props.isTotvs || props.disabled) ? 0.5 : 1)};


    text-align: center;
    text-transform: uppercase;
    color:  ${(props => (props.isTotvs || props.disabled) ? theme.colors.disabled.Desabilitado_Medio : theme.colors.blue.Azul_link)};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extraBold};
    font-size: ${theme.typography.fontSize.tagLineM};
    line-height: ${theme.typography.lineHeight.tagLineM};
    letter-spacing: ${theme.typography.letterSpacing.normal};
`;

export const Assinaturas = styled.p`
  width: 100%;
  /* max-width: 400px; */
  
  text-align: center;
  font-size: 11px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const ButtonCancelModal = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    border: 2px solid ${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ButtonSavedModal = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color:${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const ContainerButtonsModal = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerModalAddAgronomist = styled.div`
    width: 484px;
    height: auto;

    gap: 1rem;
    display: flex;
    flex-direction: column;

    >div >div{
        input:-webkit-autofill { 
         transition: background-color 600000s 0s !important;
        }

        >button{
            top: 55% !important;
        }
    }
`;

export const NotFound = styled.div`
    width: 100%;
    height: 13rem;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }
`;